import Clear from './../layouts/Clear.vue';

export default {
  path: '/users',
  component: Clear,
  children: [
    {
      path: '',
      name: 'users.index',
      component: () => import('@/views/users/index.vue'),
    },
  ],
};
